// extracted by mini-css-extract-plugin
module.exports = {"MailLogo":"MailLogo_MailLogo__25JzB"};